export const reduxDev = () => {
  // eslint-disable-next-line no-underscore-dangle
  const devtoolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  return devtoolsExtension ? devtoolsExtension() : (f) => f;
};

const reloadStyles = () => {
  document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
    if (link.href.indexOf('localhost') > -1) {
      link.href = link.href.replace(/(\?r=\d+)?$/, `?r=${Date.now()}`);
    }
  });
};

export const styleLoader = () => {
  if (module.hot) {
    module.hot.addStatusHandler((status) => {
      if (status === 'idle') {
        reloadStyles();
      }
    });
  }
};

export default reduxDev;
